import type { MenuItem } from '@wegic/ui';
import type { SettingsModalType } from '@/helpers/settingsModal';
import { Menu } from '@wegic/ui'
import '@wegic/ui/dist/components/Menu/index.css';;
import cn from 'classnames';
import { useEffect, useMemo } from 'react';
import globalEventEmitter from '@/modules/EventEmitter';
import { EVENTS } from '@/modules/EventEmitter/const';
import { SettingsTab } from '@/stores/settingsModal/types';
import styles from './index.module.less';
import {
  createBecomeAffiliateMenuItem,
  createContactUsMenuItem,
  createDividerMenuItem,
  createHelpCenterMenuItem,
  createJoinFacebookMenuItem,
  createReferAndEarnMenuItem,
  createSwitchToWegicV1MenuItem,
  useLogoutMenuItem,
  useSettingMenuItem,
} from './menuItem';

interface UserMenuProps {
  className?: string;
  onClose: () => void;
  settingsType: SettingsModalType;
}

function useMenuItems(settingsType: SettingsModalType): MenuItem[] {
  const createSettingMenuItem = useSettingMenuItem(SettingsTab.Account, settingsType);
  const createLogoutMenuItem = useLogoutMenuItem();

  return useMemo(() => {
    return [
      createSettingMenuItem(),
      createReferAndEarnMenuItem(),
      createBecomeAffiliateMenuItem({ suffixClassName: styles['share-icon'] }),
      createSwitchToWegicV1MenuItem(),
      createDividerMenuItem('divider-support'),
      createHelpCenterMenuItem({ suffixClassName: styles['share-icon'] }),
      createContactUsMenuItem({ suffixClassName: styles['share-icon'] }),
      createJoinFacebookMenuItem({ suffixClassName: styles['share-icon'] }),
      createDividerMenuItem('divider-logout'),
      createLogoutMenuItem(),
    ];
  }, [createLogoutMenuItem, createSettingMenuItem]);
}

function UserMenu(props: UserMenuProps) {
  const { className, onClose, settingsType } = props;
  const menuItems = useMenuItems(settingsType);

  useEffect(() => {
    globalEventEmitter.on(EVENTS.DROPDOWN_MENU_CLOSE, onClose);
    return () => {
      globalEventEmitter.off(EVENTS.DROPDOWN_MENU_CLOSE, onClose);
    };
  }, [onClose]);

  return <Menu className={cn(styles['user-menu'], className)} menuItems={menuItems} onAction={onClose} />;
}

export default UserMenu;
